module.exports = __webpack_public_path__ + "staticcomp/img/cover副本.03a55df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/6/cover副本.jpg
// module id = oS5q
// module chunks = 39